jQuery(function () {
    var effectTime = 500;
    var threshold = 0;
    if (window.pixelpoint.isMobile.any()) {
        effectTime = 0;
        threshold = 300;
    }

    window.pixelpoint.lazy = {
        init: function (elements, delay, force) { // , forceLoad
            delay = delay || 0;
            elements.each(function () {
                var element = $(this);
                if (!element.hasClass("lazy-initialized")) {
                    if (!force) {
                        if (element.parent().hasClass("center-cropped")) {
                            if (!element.parent().is(":visible")) {
                                return;
                            }
                        }
                        else {
                            if (!element.is(":visible")) {
                                return;
                            }
                        }
                    }
                    var options = {
                        effect: "fadeIn",
                        effectTime: effectTime,
                        threshold: threshold,
                        onError: function (element) {
                            //window.pixelpoint.images.initializeErrors(element);
                            element.trigger("error");
                            //var imageSrc = element.attr("src");
                            //var dataSrc = element.data("src");
                            //console.log("element " + dataSrc + " error");
                        },
                        afterLoad: function (element) {
                            //var imageSrc = element.attr("src");
                            //console.log("element " + imageSrc + " afterLoad");
                            if (element.parent().hasClass("center-cropped")) {
                                var imageSrc = element.attr("src");
                                element.parent().css("background-image", `url(${imageSrc})`);
                            }
                        }/*,
                        beforeLoad: function (element) {
                            var imageSrc = element.attr("src");
                            console.log("element " + imageSrc + " beforeLoad");
                        }*/
                    };
                    if (delay > 0) {
                        options.delay = delay;
                    }

                    // #31628
                    //window.executeAfterConsentExists(() => {
                        element.Lazy(options);
                        element.each(function () {
                            if (!$(this).data("src")) {
                                $(this).trigger("error");
                            }
                        });
                        element.addClass("lazy-initialized");
                    //})
                }
            });
        },
        initInterchange(elements) {
            elements.each(function () {
                if (!$(this).is("[data-lazy-interchange]")) {
                    return;
                }
                if ($(this).is(":visible")) {
                    var interchangeData = $(this).data("lazy-interchange");
                    $(this)
                        .attr("data-interchange", interchangeData)
                        .data("interchange", interchangeData)
                        .removeAttr("data-lazy-interchange");
                    $(this).one("replaced.zf.interchange", function(){
                       var backgroundImage = $(this).css("background-image");
                       if(!!backgroundImage){
                           var regex = /url\(\"(.*)\"\)/gi;
                           var matches = regex.exec(backgroundImage);

                           if(matches != null && matches.length > 1){
                               var src = matches[1];
                               var innerImg = $(this).find("img.hide.lazy");
                               if(innerImg.length > 0){
                                   var img = new Image();
                                   img.onerror = function(){
                                       innerImg.trigger("error").off("error");
                                   }
                                   img.src = src;
                               }
                           }
                       }
                       //console.log($(this).css("background-image"));
                    });
                    new Foundation.Interchange($(this));
                }
            });
        }
    };

    /*************************************************************************************** */
    /*************************************************************************************** */

   const initLazies = () => {
        window.pixelpoint.lazy.init($(".lazy"), 100);
        window.pixelpoint.lazy.initInterchange($("[data-lazy-interchange]").not(".slick-slider [data-lazy-interchange]"));
    }

   	// #31628
    //$(window).on("load", function() {
	//	initLazies();
	//});

    
    if (typeof __cmp !== 'undefined' && !!__cmp) {
        __cmp("addEventListener", ["consent", () => {
            initLazies()
        }, true], null)
    }else{
        initLazies();
    }


    $(".tabs-container, .tabs").on("change.zf.tabs", function (event, tab) {
        var tabId = tab.find("a").attr("href");
        var tabPanel = $(tabId);
        if (tabPanel.length > 0) {
            window.pixelpoint.lazy.initInterchange(
                tabPanel.find("[data-lazy-interchange]")
            );
        }
    });

    $("body").on("lazyLoaded", ".slick-initialized", function (
        e,
        slick,
        image,
        imageSource
    ) {
        if (image.parent().hasClass("center-cropped")) {
            imageSource = image.attr("src"); //get source
            var parent = $(image).parent(".center-cropped");
            parent.css("background-image", 'url("' + imageSource + '")'); //replace with background instead
            //image.attr('src',''); // remove source
        }
        if (image.parent().is("[data-lazy-interchange]")) {
            window.pixelpoint.lazy.initInterchange(
                image.parent()
            );
        }
        if (image.is("[data-lazy-interchange]")) {
            window.pixelpoint.lazy.initInterchange(
                image
            );
        }
        $(this).slick('setPosition');
    });
    $(".slickslider-full-width").on("lazyLoaded", function (
        e,
        slick,
        image,
        imageSource
    ) {
        imageSource = image.attr("src"); //get source
        parentSlide = $(image).parent(".slick-slide.slick-current");
        parentSlide.css("background-image", 'url("' + imageSource + '")'); //replace with background instead
        image.attr("src", ""); // remove source

        if (image.parent().is("[data-lazy-interchange]")) {
            window.pixelpoint.lazy.initInterchange(
                image.parent()
            );
        }
        if (image.is("[data-lazy-interchange]")) {
            window.pixelpoint.lazy.initInterchange(
                image
            );
        }

        $(this).slick('setPosition');
    });

    // on tab change load all lazy images of new tab
    $(".tabs-container, .tabs").on("change.zf.tabs", function (event, tab) {
        var tabId = tab.find("a").attr("href");
        var tabPanel = $(tabId);
        if (tabPanel.length > 0) {
            window.pixelpoint.lazy.init(tabPanel.find(".lazy"));
            window.pixelpoint.lazy.initInterchange(
                tabPanel.find("[data-lazy-interchange]")
            );
        }
    });

    window.pixelpoint.pubSub.subscribe(
        window.pixelpoint.pubSub.events.toggleOpenAfter,
        function (e, container) {
            window.pixelpoint.lazy.init($(container).find(".lazy"), 100, true);
            window.pixelpoint.lazy.initInterchange(
                $(container).find("[data-lazy-interchange]")
            );
        }
    );
});
